import type { SVGProps } from "react";
import { cn } from "~/lib/utils";

/** The brand ink for the lens: near-black on light, white on dark. */
export const INSPECTOR_BRAND_INK = "text-[#1D1D1D] dark:text-white";

/**
 * Approved Inspector mark. Keep geometry in sync with public/brand/inspector.
 *
 * `ink="brand"` (default) pins the lens to the brand ink for avatars, the
 * provider picker and chat headers. `ink="inherit"` lets it take the text
 * colour around it, for navigation where it sits among other icons that
 * follow the theme.
 */
export function InspectorIcon({
  className,
  ink = "brand",
  ...props
}: SVGProps<SVGSVGElement> & { readonly ink?: "brand" | "inherit" }) {
  return (
    <svg aria-hidden="true" focusable="false" className={cn(ink === "brand" && INSPECTOR_BRAND_INK, className)} {...props} viewBox="0 0 80 80" fill="none">
  <path fill="currentColor" fillRule="evenodd" d="M33 3a30 30 0 1 1 0 60 30 30 0 0 1 0-60Zm0 12a18 18 0 1 0 0 36 18 18 0 0 0 0-36Z"/>
  <path fill="#DE5656" d="M62 59a1.5 1.5 0 0 1 2.1.1l12.5 13.5c.8.9.2 2.4-1 2.4H62.8a2 2 0 0 1-1.5-.7l-7.2-7.8c-.7-.8-.5-1.9.4-2.4A39 39 0 0 0 62 59Z"/>
    </svg>
  );
}
